import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { useLocation } from 'react-router-dom';
import { Dialog, DialogContent, DialogTitle, DialogDescription, DialogTrigger } from './ui/dialog';
import { useLanguage } from '../lib/LanguageContext';

const SEEN_KEY = 'dimirxson-newsletter-seen';

const Newsletter = () => {
  const { language } = useLanguage();
  const { pathname } = useLocation();
  const ro = language === 'ro';
  const [open, setOpen] = useState(false);
  const [email, setEmail] = useState('');
  const [status, setStatus] = useState('idle');

  useEffect(() => {
    if (pathname !== '/') return;
    try { if (sessionStorage.getItem(SEEN_KEY)) return; } catch {}
    const timer = setTimeout(() => {
      // Avoid interrupting another form or dialog.
      if (document.querySelector('[role="dialog"]') || ['INPUT', 'TEXTAREA'].includes(document.activeElement?.tagName)) return;
      setOpen(true);
      try { sessionStorage.setItem(SEEN_KEY, '1'); } catch {}
    }, 10000);
    return () => clearTimeout(timer);
  }, [pathname]);

  const submit = async (event) => {
    event.preventDefault();
    if (status === 'loading') return;
    setStatus('loading');
    try {
      const response = await axios.post('/api/newsletter', { email: email.trim() });
      if (response.data?.subscribed !== true) throw new Error('Subscription was not confirmed');
      setStatus('success');
      setEmail('');
    } catch {
      setStatus('error');
    }
  };

  return (
    <div id="newsletter" className="mt-8 scroll-mt-28">
      <Dialog open={open} onOpenChange={(value) => {
        setOpen(value);
        try { sessionStorage.setItem(SEEN_KEY, '1'); } catch {}
      }}>
        <DialogTrigger asChild>
          <button type="button" className="border border-bone/50 px-5 py-4 text-sm text-left hover:bg-bone hover:text-ink transition-colors" data-testid="newsletter-open">
            {ro ? 'Abonează-te la newsletter' : 'Subscribe to our newsletter'} <span aria-hidden="true">→</span>
          </button>
        </DialogTrigger>
        <DialogContent
          onCloseAutoFocus={(event) => event.preventDefault()}
          className="w-[calc(100%-2rem)] max-w-lg bg-bone text-charcoal border-0 p-8 md:p-12 sm:rounded-none"
        >
          <DialogTitle className="text-3xl md:text-4xl font-bold leading-tight">
            {ro ? 'Alătură-te listei noastre de corespondență' : 'Join our mailing list'}
          </DialogTitle>
          <DialogDescription className="text-charcoal/70 leading-relaxed">
            {ro ? 'Primește noutăți despre expoziții, vernisaje și evenimentele galeriei.' : 'Receive news about exhibitions, openings and gallery events.'}
          </DialogDescription>
          {status === 'success' ? (
            <p role="status" className="mt-4">{ro ? 'Mulțumim! Abonarea ta a fost înregistrată.' : 'Thank you! Your subscription has been saved.'}</p>
          ) : (
            <form onSubmit={submit} className="mt-4 space-y-5" data-testid="newsletter-form">
              <label className="block text-sm">
                {ro ? 'Adresă de email' : 'Email address'}
                <input type="email" name="email" autoComplete="email" required maxLength={254} value={email} onChange={(event) => setEmail(event.target.value)} className="mt-2 w-full border-b border-charcoal/40 bg-transparent py-3 outline-none focus:border-charcoal" data-testid="newsletter-input" />
              </label>
              <button type="submit" disabled={status === 'loading'} className="w-full bg-charcoal text-bone px-5 py-3 disabled:opacity-50" data-testid="newsletter-submit">
                {status === 'loading' ? (ro ? 'Se trimite…' : 'Submitting…') : (ro ? 'Abonează-te' : 'Subscribe')}
              </button>
              {status === 'error' && <p role="alert" className="text-sm">{ro ? 'Abonarea nu a putut fi salvată. Te rugăm să încerci din nou.' : 'Your subscription could not be saved. Please try again.'}</p>}
            </form>
          )}
        </DialogContent>
      </Dialog>
    </div>
  );
};

export default Newsletter;
